import { useEffect, useRef, useState } from "react";

const Notification = ({ notification, onClose, onHeightUpdate, prevNotificationsHeight }) => {
    const { id, icon, title, message, type, autoClose, isLeaving, order } = notification;
    const [isVisible, setIsVisible] = useState(false);
    // const [isEntering, setIsEntering] = useState(true);
    const notificationRef = useRef(null);
  
    useEffect(() => {
        if (notificationRef.current) {
            const height = notificationRef.current.offsetHeight;
            onHeightUpdate(id, height);
            // console.log(notificationRef.current.getBoundingClientRect().height)
        }
    }, [id, onHeightUpdate, message]);

    useEffect(() => {
        // Анимация появления
        const timer = setTimeout(() => setIsVisible(true), 10);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (autoClose === false || isLeaving) return;
        const timer = setTimeout(() => onClose(id), autoClose);
        return () => clearTimeout(timer);
    }, [id, autoClose, isLeaving, onClose]);

    const offset = -prevNotificationsHeight;

    return (
        <li 
            ref={notificationRef}
            className={`notification ${type} ${isVisible?'visible':'hidden'} ${isLeaving?'leaving':''}`}
            style={{
                // transform: `translateY(${order * (height + 0)}px)`,
                transform: `translateY(${offset}px) translateX(${isLeaving ? 30 : 0}px)`,
                transition: 'transform 0.3s ease, opacity 0.3s ease',
            }}
        >
            <div className="title">
                <div className="icon">{icon}</div>
                <div className="text">{title}</div>
            </div>
            <div className="content">{message}</div>
            {/* <button 
                className="notification__close"
                onClick={() => onClose(id)}
                aria-label="Close notification"
            >
                &times;
            </button> */}
            <div className="buttons" onClick={(event) => {
                event.preventDefault();
                onClose(id)
            }}>
                <button className="activeButton" id="notificationButton">Понятно</button>
            </div>
        </li>
    );
  };

  export default Notification;
  